/** Mantém só dígitos, no máximo 8 (número do pedido GAR). */
export function sanitizeGarOrder(input: string): string {
  return input.replace(/\D/g, '').slice(0, 8);
}

/**
 * Máscara progressiva: CPF enquanto ≤11 dígitos; a partir do 12º, CNPJ (até 14 dígitos).
 */
export function formatCpfCnpjInput(input: string): string {
  const d = input.replace(/\D/g, '').slice(0, 14);
  if (d.length === 0) return '';

  if (d.length <= 11) {
    const a = d.slice(0, 3);
    const b = d.slice(3, 6);
    const c = d.slice(6, 9);
    const rest = d.slice(9, 11);
    if (d.length <= 3) return a;
    if (d.length <= 6) return `${a}.${b}`;
    if (d.length <= 9) return `${a}.${b}.${c}`;
    return `${a}.${b}.${c}-${rest}`;
  }

  const a = d.slice(0, 2);
  const b = d.slice(2, 5);
  const c = d.slice(5, 8);
  const e = d.slice(8, 12);
  const f = d.slice(12, 14);
  if (d.length <= 2) return a;
  if (d.length <= 5) return `${a}.${b}`;
  if (d.length <= 8) return `${a}.${b}.${c}`;
  if (d.length <= 12) return `${a}.${b}.${c}/${e}`;
  return `${a}.${b}.${c}/${e}-${f}`;
}

export function getDocumentDigits(formatted: string): string {
  return formatted.replace(/\D/g, '');
}
